import React, { forwardRef, useRef, useState } from "react"
import {
  DetailsTrailing,
  StyledInput,
  StyledLabel,
  StyledTextFieldFormItem,
} from "./styled"

interface IProps {
  label: string
  value?: string
  onChange?: (value: string) => void
  placeholder?: string
  detailTrailing?: string
  isError?: boolean
  disabled?: boolean
  unit?: string
  readOnly?: boolean
  onFocus?: () => void
  validator?: (value: string) => boolean
  setIsValid?: (isValid: boolean) => void
  onEnter?: () => void
}

const TextField = forwardRef((props: IProps, ref: any) => {
  const {
    detailTrailing,
    isError = false,
    disabled = false,
    unit,
    readOnly = false,
    onFocus,
    onChange,
    validator,
    setIsValid,
    placeholder,
    value,
    label,
    onEnter,
  } = props

  const isTouched = useRef(false)

  const handleChange = (nextValue: string) => {
    if (disabled) {
      return
    }

    onChange?.(nextValue)

    const isValid = validator ? validator(nextValue) : true

    // Validate email only when the field is touched
    if (isTouched.current && !isValid) {
      setIsValid?.(false)
    } else {
      setIsValid?.(true)
    }
  }

  const handleBlur = () => {
    isTouched.current = true
    handleChange(value ?? "")
  }
  return (
    <StyledTextFieldFormItem>
      <StyledLabel>{label}</StyledLabel>

      <StyledInput
        ref={ref}
        $disabled={disabled}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleBlur()
            setTimeout(() => {
              onEnter?.()
            }, 0)
          }
        }}
        onFocus={onFocus}
        readOnly={readOnly}
        onBlur={handleBlur}
        $isError={isError}
        placeholder={placeholder}
        value={value ?? ""}
        onChange={(e) => {
          handleChange(e.target.value)
        }}
        autoComplete="off"
        style={{ paddingRight: detailTrailing ? "28px" : "16px" }}
      />
      {detailTrailing && <DetailsTrailing>{detailTrailing}</DetailsTrailing>}
      {unit && <DetailsTrailing $isUnit>{unit}</DetailsTrailing>}
    </StyledTextFieldFormItem>
  )
})

export default TextField
